import React from 'react';
import HwzComponent from '../../../common/component/HwzComponent';
import { Button, Modal } from 'antd';
import Lang from '../../../common/model/global/Lang';
import Moon from '../../../common/model/global/Moon';
import { ExclamationCircleFilled } from '@ant-design/icons';
import './MatterDeleteModal.less';
import Preference from '../../../common/model/preference/Preference';

interface IProps {
  isSpace: boolean; // 是否是空间，空间下暂不展示放入回收站逻辑
  onSoftDel: () => void;
  onHardDel: () => void;
  onClose: () => void;
}

interface IState {}

export default class MatterDeleteModal extends HwzComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }

  static preference: Preference = Moon.getSingleton().preference;

  static open(isSpace: boolean, onSoftDel: () => void, onHardDel: () => void) {
    let modal = Modal.warning({
      className: 'delete-modal custom-handle-modal matter-delete-modal-container',
      title: Lang.t('delete'),
      icon: <ExclamationCircleFilled twoToneColor="#FFDC00" />,
      okCancel: false,
      content: (
        <MatterDeleteModal
          isSpace={isSpace}
          onSoftDel={() => {
            onSoftDel();
            modal.destroy();
          }}
          onHardDel={() => {
            onHardDel();
            modal.destroy();
          }}
          onClose={() => {
            modal.destroy();
          }}
        />
      ),
    });
  }

  render() {
    return (
      <div className="matter-delete-modal">
        <p>{Lang.t('actionDeleteConfirm')}</p>
        <div className="button-container">
          <Button className="cancel-btn" onClick={this.props.onClose}>
            {Lang.t('cancel')}
          </Button>
          <Button type="primary" danger onClick={this.props.onHardDel}>
            {Lang.t('deleteDirectly')}
          </Button>
          {!this.props.isSpace &&
            MatterDeleteModal.preference.getRecycleBinStatus() && (
              <Button
                type="primary"
                className="soft-delete-btn"
                onClick={this.props.onSoftDel}
              >
                {Lang.t('matter.intoRecycleBin')}
              </Button>
            )}
        </div>
      </div>
    );
  }
}